import { useTranslation } from "react-i18next";
import UserService from "../../../services/UserService";
import i18n from "../../../i18n"
import "./style.scss";

const SELECTED_TENANT = (props: any) => {

    const [t] = useTranslation("translations");

    const location = UserService.getAttribute<"savedLocationTenant">("savedLocationTenant");

    if (location.type === "tenant") {
        return (<div className="SELECTED_TENANT_container">
            {location.secondary_image && <img src={location.secondary_image} alt={location.name}/>}
            <p>{i18n.t("SelectedTenant.brought_to_you_by", { natenanme: location.name})}</p>

            {location.url && (
                <a href={location.url} rel="noreferrer" target="_blank">{t("SelectedTenant.learn_more")}</a>
            )}
        </div>)
    }
        return (<div className="SELECTED_TENANT_container">
            {t("SelectedTenant.generic_brought_to_you_by")}
            <a href="https://health.gov.on.ca/en/pro/programs/connectedcare/oht/default.aspx" rel="noreferrer" target="_blank">{t("SelectedTenant.learn_more")}</a>
        </div>)
    
  
};

export default SELECTED_TENANT;

export const SelectedTenantConfig = () => []